export const TARIFICATION_ENTREPRISE = 100;

export const TARIFICATION_BENEFICIAIRES = 5;